import type { ComponentPropsWithRef, ReactNode } from "react";
import { forwardRef } from "react";
import { classNames } from "@/react/helpers/twMergeWithCN";

export interface ItemCardProps extends ComponentPropsWithRef<"div"> {
  description: ReactNode;
  header: ReactNode;
  image: ReactNode;
}

export const ItemCard = forwardRef<HTMLDivElement, ItemCardProps>(
  ({ image, header, description, className, ...rest }, ref) => (
    <div
      ref={ref}
      className={classNames(
        "wb-flex wb-flex-col md:wb-flex-row wb-items-center wb-gap-2 md:wb-gap-4",
        className,
      )}
      {...rest}
    >
      <div className="wb-flex wb-flex-col wb-gap-4">{image}</div>
      <div className="wb-mt-2 wb-flex wb-flex-col wb-gap-1 wb-items-center md:wb-items-start">
        {header}
        {description}
      </div>
    </div>
  ),
);

ItemCard.displayName = "ItemCard";
